.wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 34px 40px 80px;
}
.head {
  margin-bottom: 22px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.head h1 {
  font-size: 28px;
  margin-top: 2px;
}
.eyebrow {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--blue-text);
}
.note {
  color: var(--muted);
}
.alert {
  background: var(--amber-bg);
  border: 1px solid var(--amber-line);
  border-left: 5px solid var(--amber-line);
  border-radius: 11px;
  padding: 12px 15px;
  color: var(--ink);
  font-size: 14.5px;
}
.table {
  width: 100%;
  border-collapse: collapse;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  font-size: 14px;
  overflow: hidden;
}
.table th,
.table td {
  text-align: left;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}
.table thead th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
}
.table tbody tr:last-child td {
  border-bottom: none;
}
.table .num {
  text-align: right;
  white-space: nowrap;
}
.title {
  font-weight: 700;
  color: var(--blue-d);
  text-decoration: none;
}
.title:hover {
  color: var(--blue-text);
  text-decoration: underline;
}
.ref {
  display: block;
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}
.status {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 999px;
  background: var(--bg);
  color: var(--muted);
  white-space: nowrap;
}

@media (max-width: 820px) {
  .wrap {
    padding: 22px 18px 60px;
  }
  .table {
    display: block;
    overflow-x: auto;
  }
}

.newBtn {
  border: 1px solid var(--blue-d);
  background: var(--blue-d);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 18px;
  border-radius: 9px;
  text-decoration: none;
}
.newBtn:hover {
  background: var(--blue-l);
  border-color: var(--blue-l);
}
.filters {
  display: flex;
  align-items: flex-end;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.filter {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
}
.filter input,
.filter select {
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 9px 11px;
  font-size: 14px;
  background: #fff;
  min-width: 220px;
  font-weight: 400;
}
.check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--body);
  padding-bottom: 9px;
}
